import * as React from "react";
import { useState, useEffect } from "react";

import { getConfig } from "../../../core/getNode";
import { useEmailDataContext } from "../../../partials/dataContext";
import { useScreenContext } from "../../../partials/screenContext";
import { useDispatch, useSelector } from "react-redux";

// UI
import LoadingSpinner from "../../../partials/loading";
import EmailConfigTemplateItem from "./EmailConfigTemplateItem";
// import EmailConfigBrandItem from "./EmailConfigBrandItem";
// import EmailConfigLanguageItem from "./EmailConfigLanguageItem";
import MessageBox from "../../../partials/MessageBox";

export default function EmailConfig() {
  const [isLoading, setLoading] = useState(true);

  const [data, setData] = useState({});

  const [messageBoxVisible, setMessageBoxVisible] = useState(false);
  const [messageTitle, setMessageTitle] = useState("");
  const [messageBody, setMessageBody] = useState("");

  const { selectedTemplate, setSelectedTemplate, selectedBrand, setSelectedBrand } = useEmailDataContext();
  const { setCurrentScreen } = useScreenContext();

  // redux
  const system = useSelector((state) => state.systemReducer);
  const config = useSelector((state) => state.configReducer);
  const token = useSelector((state) => state.tokenReducer);

  // hooks
  const dispatch = useDispatch();

  useEffect(() => {
    getContent();
  }, []);

  const getContent = () => {
    setLoading(true);
    setMessageBoxVisible(false);
    setMessageTitle("");
    setMessageBody("");

    getConfig()
      .then((response) => {
        if (system.subdomain && response.data[system.subdomain]) {
          dispatch({ type: "SAVE_CONFIG", payload: response.data[system.subdomain] });
          setData(response.data[system.subdomain]);
          setMessageBoxVisible(false);
        } else {
          setMessageBoxVisible(true);
          setMessageTitle("Error");
          setMessageBody("Failed to retrieve the required data! Please restart and try again.");
        }

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setMessageBoxVisible(true);
        setMessageTitle("Error");
        setMessageBody("Failed to retrieve the required data! Please restart and try again.");
      });
  };

  const onNext = () => {
    if (selectedTemplate && selectedBrand) {
      setCurrentScreen("/content");
    }
  };

  return (
    <div className="app-email-config-wrapper">
      <div id="email-config-screen-wrapper" className="email-config-screen-wrapper">
        {isLoading ? (
          <div
            className="w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ position: "absolute", top: 0, left: 0, backgroundColor: "rgba(255,255,255,0.5)", zIndex: 9999 }}
          >
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <div className="message-box-wrapper">
              <MessageBox messageBoxVisible={messageBoxVisible} messageTitle={messageTitle} messageBody={messageBody} />
            </div>

            <div
              id="email-config-templates-view-content"
              className={`email-config-templates-view-content block-display-visible`}
            >
              <div className="email-config-template-items-wrapper">
                <div className="available-email-config-templates-title">
                  <span>Configure Email template and brand</span>
                </div>
                <div id="email-config-template-items">
                  {data?.templates?.map((template, index) => {
                    return (
                      <EmailConfigTemplateItem
                        key={`key-${index}`}
                        itemIndex={index}
                        config={config}
                        system={system}
                        token={token}
                        templateIdentityCode={template.identity_code}
                        templateName={template.name}
                        templateDescription={template.description}
                        mainImageUrl={template.main_image_url}
                        selectedTemplate={selectedTemplate}
                        addSelectedTemplateItem={(item) => {
                          setSelectedTemplate(item);
                        }}
                        brands={data.brands}
                        selectedBrand={selectedBrand}
                        setSelectedBrand={setSelectedBrand}
                        onNext={onNext}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
